import CdpArticle from '@/types/purchaseRequest/cdpArticle'
import { BaseService } from './../../base'
export class CdpArticleService extends BaseService<CdpArticle>() {
    static get entity (): string {
        return 'cdp_article'
    }
    static get responseName (): string {
        return 'cdp_article'
    }
}